<template>
  <div class="serve">
    <banner/>
    <div class="containerbox">
    <div class="container">
      <p class="container-title">
        服务优势
      </p>
      <div class="container-imgbox">
        <img src="../../assets/pimgs/p_service.png">
      </div>
      <div class="container-textboxa">
        <p class="container-texttitle">一、优秀的技术团队</p>
        <P class="container-text">
          迪孚拥有稳定、专业、高效的技术研发队伍，主要人员均毕业于国内知名大学，具有一流的专业水平、
          严谨的工作作风，可以确保工作中的每个环节为客户提供最为专业、高效、优质、全面的服务。
        </P>
      </div>
      <div class="container-textboxb">
        <p class="container-texttitle">二、良好的职业素养</p>
        <P class="container-text">
          我们的团队具有良好敬业精神和职业道德，能够任劳任怨地勤奋工作。遵守“专业、诚信、高效、严谨、
          优质”的基本原则。
        </P>
      </div>
      <div class="container-textboxb">
        <p class="container-texttitle">三、贴心服务全程技术指导</p>
        <P class="container-text">
          可以做到上门勘测，全程辅导上线，无线网络全频段接入，有专人负责项目的跟进，保障项目高效优质
          顺利进行。
        </P>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import banner from '@/mobile/components/banner'
export default {
  name: 'Serve',
  components: {
    banner
  }
}
</script>
<style>
@import url('../../styles/reset.css');

</style>
<style lang="scss" scoped>
.containerbox{
  width: 100%;
  height: 100%;
  color: #5e5e5e;
  // font-size: 16px;
  display: flex;
  justify-content: center;
  font-size: 0.16rem;
}
.container{
  // width: 680px;
  width: 6.8rem;
}
.container-title{
  margin: 0!important;
  // height: 110px;
  // line-height: 110px;
  // font-size: 24px;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.24rem;
  text-align: center;
}
.container-imgbox{
  // height: 380px;
  height: 3.80rem;
  display: flex;
  align-items: center;
}
.container-imgbox img{
  width: 100%;
  // height: 336px;
  height: 3.36rem;
}
.container-textboxa{
  // height: 168px;
  // padding: 20px 0;
  font-size: 0.16rem;
  height: 1.68rem;
  padding: 0.20rem 0;
}
.container-textboxb{
  // height: 133px;
  // padding: 20px 0;
  font-size: 0.16rem;
  height: 1.33rem;
  padding: 0.20rem 0;
}
.container-texttitle{
  display: block;
  text-align: left;
  // height: 31px;
  // line-height: 31px;
  font-size: 0.16rem;
  height: 0.31rem;
  line-height: 0.31rem;
}
.container-text{
  display: block;
  text-align: left;
  text-indent:2em;
  height: 0.31rem;
  line-height: 0.31rem;
  font-size: 0.16rem;
  // height: 31px;
  // line-height: 31px;
}

</style>
